import Cookies from 'js-cookie';

export const ACCESS_TOKEN_COOKIE_NAME = 'accessToken';
export const LEGACY_TOKEN_COOKIE_NAME = 'token';
export const ACCESS_TOKEN_STORAGE_KEY = 'accessToken';
export const REFRESH_TOKEN_COOKIE_NAME = 'refreshToken';
export const RECENT_APP_COOKIE_NAME = 'recentapp';
export const RECENT_APP_STORAGE_KEY = 'recentapp';
export const CURRENT_APP_NAME = process.env.REACT_APP_SESSION_APP_NAME || 'msweb';

const REFRESH_COOKIE_OPTIONS = {
  secure: false,
  sameSite: 'Strict',
  path: '/auth/refresh',
  expires: 7,
};

const COOKIE_REMOVE_OPTIONS = {
  path: '/',
};

const getStorage = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.localStorage;
};

const clearLegacyCookies = () => {
  Cookies.remove(ACCESS_TOKEN_COOKIE_NAME, COOKIE_REMOVE_OPTIONS);
  Cookies.remove(LEGACY_TOKEN_COOKIE_NAME, COOKIE_REMOVE_OPTIONS);
  Cookies.remove(RECENT_APP_COOKIE_NAME, COOKIE_REMOVE_OPTIONS);
};

export const getAuthToken = () => {
  const storage = getStorage();
  const accessToken = storage?.getItem(ACCESS_TOKEN_STORAGE_KEY);

  if (accessToken) {
    clearLegacyCookies();
    return accessToken;
  }

  const legacyToken = Cookies.get(LEGACY_TOKEN_COOKIE_NAME);
  if (legacyToken) {
    if (storage) {
      storage.setItem(ACCESS_TOKEN_STORAGE_KEY, legacyToken);
    }
    clearLegacyCookies();
    return legacyToken;
  }

  return null;
};

export const getRecentApp = () => {
  const storage = getStorage();
  const recentApp = storage?.getItem(RECENT_APP_STORAGE_KEY);

  if (recentApp) {
    clearLegacyCookies();
    return recentApp;
  }

  const legacyRecentApp = Cookies.get(RECENT_APP_COOKIE_NAME);
  if (legacyRecentApp) {
    if (storage) {
      storage.setItem(RECENT_APP_STORAGE_KEY, legacyRecentApp);
    }
    clearLegacyCookies();
    return legacyRecentApp;
  }

  return null;
};

export const persistAuthSession = (token) => {
  if (!token) {
    return;
  }

  const storage = getStorage();
  if (storage) {
    storage.setItem(ACCESS_TOKEN_STORAGE_KEY, token);
    storage.setItem(RECENT_APP_STORAGE_KEY, CURRENT_APP_NAME);
  }
  clearLegacyCookies();
};

export const persistRefreshSession = (refreshToken) => {
  if (!refreshToken) {
    return;
  }

  Cookies.set(REFRESH_TOKEN_COOKIE_NAME, refreshToken, REFRESH_COOKIE_OPTIONS);
};

export const clearAuthSession = () => {
  const storage = getStorage();
  if (storage) {
    storage.removeItem(ACCESS_TOKEN_STORAGE_KEY);
    storage.removeItem(RECENT_APP_STORAGE_KEY);
  }
  clearLegacyCookies();
};

export const hasValidAppSession = () => {
  const token = getAuthToken();

  if (!token) {
    return true;
  }

  return getRecentApp() === CURRENT_APP_NAME;
};

export const invalidateForeignAppSession = () => {
  const token = getAuthToken();
  const recentApp = getRecentApp();

  if (!token) {
    if (recentApp) {
      const storage = getStorage();
      if (storage) {
        storage.removeItem(RECENT_APP_STORAGE_KEY);
      }
    }
    clearLegacyCookies();
    return false;
  }

  if (recentApp !== CURRENT_APP_NAME) {
    clearAuthSession();
    return true;
  }

  return false;
};
